export default __webpack_public_path__ + "static/media/proxyintegration.79e364c1.png";